(function () {
  'use strict';
  const core = {
    initialVariant(product, preferredId) {
      return product.variants.find(v => v.id === preferredId) || product.variants.find(v => v.available) || product.variants[0];
    },
    totals(variants) {
      return {original: variants.reduce((sum, v) => sum + v.price, 0), offer: Math.max(...variants.map(v => v.price))};
    },
    items(variants, shipDate) {
      if (variants.length !== 2 || variants.some(v => !v || !v.id || !v.available)) throw new Error('Please choose two available hats.');
      const grouped = new Map();
      variants.forEach(v => {
        if (grouped.has(v.id)) grouped.get(v.id).quantity += 1;
        else grouped.set(v.id, {id: v.id, quantity: 1, properties: {'Pre-order ships': shipDate}});
      });
      return [...grouped.values()];
    }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (typeof document === 'undefined') return;
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const status = root.querySelector('[data-status]');
    const add = root.querySelector('[data-add]');
    const mobileAdd = root.querySelector('[data-mobile-add]');
    let data;
    try {data = JSON.parse(root.querySelector('[data-ag-data]').textContent);} catch (_) {
      status.textContent = 'The product selector could not load. Please refresh the page.'; return;
    }
    const products = [...new Map(data.products.filter(p => p.variants && p.variants.length).map(p => [p.id, p])).values()];
    if (!products.length) {status.textContent = 'No Lo-Pro products are available. Please select eligible products in the theme editor.'; return;}
    const current = products.find(p => p.id === data.currentId) || products[0];
    const preferred = Number(new URLSearchParams(location.search).get('variant'));
    const first = core.initialVariant(current, preferred);
    const selections = [{product:current, variant:first}, {product:current, variant:core.initialVariant(current)}];
    let busy = false;
    const selectors = root.querySelector('[data-selectors]');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency', currency:data.currency});
    const money = cents => formatter.format(cents / 100) + ' ' + data.currency;
    function image(url, alt) {const img=document.createElement('img'); img.src=url; img.alt=alt; img.width=110; img.height=110; img.loading='lazy'; return img;}
    function label(text) {const span=document.createElement('span'); span.textContent=text; return span;}
    function tile(text, url, selected, key, action, disabled, note) {
      const button=document.createElement('button'); button.type='button'; button.className='ag-bogo-tile';
      button.setAttribute('aria-pressed', String(selected)); button.dataset.focusKey=key;
      button.disabled=busy;
      if(disabled) {button.classList.add('ag-bogo-unavailable'); button.setAttribute('aria-label',text+' — unavailable to order');}
      button.append(image(url, text), label(text));
      if(note) {const small=document.createElement('small'); small.textContent=note; button.append(small);}
      button.addEventListener('click', action); return button;
    }
    function showPhoto(selection, slot = 0) {
      root.querySelector('[data-hero]').src=selection.variant.image;
      root.querySelector('[data-hero]').alt=selection.product.title + ' — ' + selection.variant.title;
      root.querySelector('[data-caption]').textContent='Hat '+(slot+1)+' · '+selection.product.title + ' / ' + selection.variant.title + (selection.variant.note ? ' · '+selection.variant.note : '');
    }
    function render(focusKey) {
      selectors.replaceChildren();
      selections.forEach((selection, slot) => {
        const fieldset=document.createElement('fieldset'); fieldset.className='ag-bogo-picker';
        const legend=document.createElement('legend'); legend.textContent=(slot+1)+'. '+(slot===0?'CHOOSE YOUR FIRST HAT':'CHOOSE YOUR SECOND HAT'); fieldset.append(legend);
        const preview=document.createElement('div'); preview.className='ag-bogo-selection';
        preview.append(image(selection.variant.image,selection.product.title+' — '+selection.variant.title));
        const previewText=document.createElement('div'); previewText.append(label(selection.product.title),label(selection.variant.title));
        preview.append(previewText); fieldset.append(preview);
        const styleLabel=document.createElement('p'); styleLabel.textContent='Style: '+selection.product.title; fieldset.append(styleLabel);
        const styles=document.createElement('div'); styles.className='ag-bogo-tiles ag-bogo-styles';
        products.forEach(p => {
          const key='style-'+slot+'-'+p.id;
          styles.append(tile(p.title,p.image,p.id===selection.product.id,key,()=>{
            selections[slot]={product:p,variant:core.initialVariant(p)}; status.textContent=''; showPhoto(selections[slot], slot); render(key);
          },false,p.variants.some(v=>v.available)?'':'Unavailable'));
        });
        fieldset.append(styles);
        const colourLabel=document.createElement('p'); colourLabel.textContent='Colour: '+selection.variant.title; fieldset.append(colourLabel);
        const variants=document.createElement('div'); variants.className='ag-bogo-tiles ag-bogo-colours';
        selection.product.variants.forEach(v => {
          const key='variant-'+slot+'-'+v.id;
          variants.append(tile(v.title,v.image,v.id===selection.variant.id,key,()=>{
            selections[slot].variant=v; status.textContent=''; showPhoto(selections[slot], slot); render(key);
          },!v.available,!v.available?'Unavailable':v.note));
        });
        fieldset.append(variants);
        if(selection.variant.note) {const note=document.createElement('small'); note.textContent=selection.variant.note; fieldset.append(note);}
        selectors.append(fieldset);
      });
      const selectedVariants=selections.map(s=>s.variant);
      const priced=selectedVariants.every(v=>Number.isFinite(v.price));
      const totals=priced ? core.totals(selectedVariants) : null;
      root.querySelector('[data-original]').textContent=priced ? money(totals.original) : '';
      root.querySelector('[data-total]').textContent=priced ? money(totals.offer) : 'Choose available hats';
      const unavailable=selectedVariants.some(v=>!v.available);
      add.disabled=busy || unavailable;
      add.textContent=busy?'ADDING YOUR PAIR…':unavailable?'CHOOSE AVAILABLE HATS':'PRE-ORDER MY PAIR →';
      if(mobileAdd) {
        mobileAdd.disabled=add.disabled;
        mobileAdd.textContent=busy?'ADDING…':unavailable?'CHOOSE HATS':'PRE-ORDER PAIR →';
        root.querySelector('[data-mobile-total]').textContent=priced ? money(totals.offer) : 'Select your pair';
      }
      if(unavailable) status.textContent='One or more selected hats are unavailable. Choose an available style and colour for each hat.';
      if(focusKey) {const target=[...selectors.querySelectorAll('[data-focus-key]')].find(el=>el.dataset.focusKey===focusKey); if(target) target.focus();}
    }
    root.querySelectorAll('[data-gallery]').forEach(button => button.addEventListener('click',()=>{
      root.querySelector('[data-hero]').src=button.dataset.gallery;
      root.querySelector('[data-hero]').alt=button.dataset.alt;
      root.querySelector('[data-caption]').textContent=button.dataset.alt;
    }));
    if(mobileAdd) mobileAdd.addEventListener('click',()=>add.click());
    add.addEventListener('click',async()=>{
      if(busy) return;
      let items;
      try {items=core.items(selections.map(s=>s.variant),data.shipDate);} catch(error) {status.textContent=error.message; return;}
      busy=true; render(); status.textContent='Adding both hats to your cart…';
      const shopRoot=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const response=await fetch(shopRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok) throw new Error(typeof result.description==='string'?result.description:'Unable to add this pair. Check availability and try again.');
        location.assign(shopRoot+'cart');
      } catch(error) {
        busy=false; render();
        status.textContent=error instanceof TypeError ? 'Connection interrupted. Check your cart before trying again; your hats may already have been added. ' : error.message+' ';
        const link=document.createElement('a'); link.href=shopRoot+'cart'; link.textContent='View cart'; status.append(link);
        status.scrollIntoView({behavior:'smooth',block:'center'});
      }
    });
    render(); showPhoto(selections[0]);
  }
  function initAll(scope) {if(scope.matches && scope.matches('[data-ag-bogo]')) initialize(scope); scope.querySelectorAll('[data-ag-bogo]').forEach(initialize);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initAll(document)); else initAll(document);
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
}());
